/* eslint-disable import/no-cycle */
import { getI18nLanguage } from '@/plugins/i18n'
import { apiHttp } from '../axiosApi'
import { publicWaiver } from '../config/apiRoute'

const publicHeaders = () => ({
  Accept: 'application/json',
  'Accept-Language': getI18nLanguage(),
})

/** Todo lo que la pagina /w/:token necesita (club, reserva, roster con quien
 *  ya firmo, documento EN/ES). 404 token inexistente, 410 vencido. */
export const getPublicWaiver = async token => apiHttp(
  'GET',
  `${publicWaiver}${token}`,
  {},
  { headers: publicHeaders() },
  true,
  'v3',
)

/** Menores que este adulto ya firmó en el club (versión vigente). `form`:
 *  FormData con phone_code, phone_number y email — los TRES, el backend no
 *  lista chicos de nadie con un solo dato. */
export const getKnownMinors = async (token, form) => apiHttp(
  'POST',
  `${publicWaiver}${token}/minors`,
  form,
  { headers: { ...publicHeaders(), 'Content-Type': 'multipart/form-data' } },
  true,
  'v3',
)

/** Firma dibujada. `form` es un FormData: full_name, phone_code, phone_number,
 *  email, marketing_consent, lang, signature_png (Blob), player_match_id?, op?,
 *  sign_self ('true'|'false'), minors (JSON: [{full_name, birthdate,
 *  player_match_id?} | {signature_id, player_match_id?}]) */
export const signPublicWaiver = async (token, form) => apiHttp(
  'POST',
  `${publicWaiver}${token}/sign`,
  form,
  { headers: { ...publicHeaders(), 'Content-Type': 'multipart/form-data' } },
  true,
  'v3',
)
